import { X } from '@untitled-ui/icons-react';
import clsx from 'clsx';
import type { FC, ReactNode } from 'react';

import { useSidePanelStore } from '@/components/side-panel/useSidePanelStore';

import styles from './AISidePanel.module.scss';

interface AISidePanelHeaderProps {
  onClose?: () => void;
  title?: string;
  toolbarButtons?: ReactNode[];
}

export const AISidePanelHeader: FC<AISidePanelHeaderProps> = ({
  onClose,
  title,
  toolbarButtons,
}) => {
  function close() {
    if (onClose) {
      onClose();
    }
    closeSidePanel();
  }

  const { close: closeSidePanel } = useSidePanelStore();

  return (
    <div
      className={clsx(
        styles.sidePanelHeader,
        'flex flex-row items-center justify-between py-4 px-4 min-h-[34px]'
      )}
    >
      <h2>{title || 'Risksmart AI'}</h2>
      <div className={styles.sidePanelHeaderButtons}>
        {toolbarButtons?.map((button, index) => {
          return <div key={index}>{button}</div>;
        })}
        <button onClick={close} title={'Close'} aria-label={'Close'}>
          <X />
        </button>
      </div>
    </div>
  );
};
